import React from 'react';
import WithFlowComponent from '../WithFlowComponent';
import FlowComponentHeader from '../components/FlowComponentHeader';
import FlowComponentDefault from '../components/FlowComponentDefault';

export default class FlowRendererComponent extends React.Component {
    constructor(props) {
        super(props);
    }

    renderComponent = (component, props) => {
        const { name } = component;

        if (typeof this.props.renderComponent === 'function') {
            const renderOverwrite = this.props.renderComponent(component, props);

            if (renderOverwrite) {
                return renderOverwrite;
            }
        }

        if (name === 'header') {
            return <FlowComponentHeader {...props} />;
        }

        return <FlowComponentDefault {...props} />;
    }

    render() {
        const { components, path, id, ...passProps } = this.props;

        return (
            <React.Fragment>
                {components?.map((component, componentIndex) => {
                    const componentPath = `${path}.${componentIndex}`;
                    const componentId = `${id}.${componentIndex}-${component?.id}`;

                    return (
                        <WithFlowComponent
                            key={componentId}
                            path={componentPath}
                            id={componentId}
                            component={component}
                            {...passProps}
                        >
                            {(props) => {
                                return this.renderComponent(component, props);
                            }}
                        </WithFlowComponent>
                    )
                })}

            </React.Fragment>
        );
    }
}
